import type { AmenityReservation } from '@yawi/types';
import { CalendarClock, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PendingReservationsCardProps {
  reservations: AmenityReservation[];
  loading?: boolean;
}

export function PendingReservationsCard({ reservations, loading }: PendingReservationsCardProps) {
  const navigate = useNavigate();

  if (loading || reservations.length === 0) return null;

  const count = reservations.length;

  return (
    <div className="flex items-center gap-3 bg-[#F4EDDD] border-[0.5px] border-[#E3D6BA] rounded-lg px-3 py-2">
      <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 bg-[#EF9F27] text-white">
        <CalendarClock size={16} />
      </div>
      <p className="flex-1 text-[13px] font-medium leading-tight" style={{ color: '#3A2400' }}>
        <span className="font-semibold">{count}</span>{' '}
        {count === 1 ? 'reserva pendiente por confirmar' : 'reservas pendientes por confirmar'}
      </p>
      <button
        onClick={() => {
          const params = new URLSearchParams({ status: 'PENDING' });
          if (count === 1) params.set('search', reservations[0].reservationCode || reservations[0].id);
          navigate(`/admin/reservas?${params.toString()}`);
        }}
        className="flex-shrink-0 text-[11px] font-medium text-white bg-[#EF9F27] hover:bg-[#854F0B] rounded-[20px] px-3 py-1 flex items-center gap-0.5 whitespace-nowrap"
      >
        Revisar <ChevronRight size={14} />
      </button>
    </div>
  );
}
